module.exports = __webpack_public_path__ + "static/media/focused.460620b5.svg";